module.exports = __webpack_public_path__ + "static/media/search.c7a8d2e7.svg";